import { render, staticRenderFns } from "./ButtonGroupDropdownSupport.vue?vue&type=template&id=1b28ef2f"
import script from "./ButtonGroupDropdownSupport.vue?vue&type=script&lang=js"
export * from "./ButtonGroupDropdownSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports